export enum AutomaticCorrectionCheckType {
  ExcessAuditFirms = 2,
  UnlinkedDirectors = 3,
  ExecutiveMisclassification = 4,
  ZeroValueLargeShareholders = 5,
  LeaderNotIndependent = 6,
  FormerCeoNotFlagged = 7,
  DirectorsMissingHonorificTitle = 8,
  CeoTypeNotFinancialExpert = 9,
  AuditCommitteeFinancialExpertNotFlagged = 10
}
